import { IStyle } from '@fluentui/react';

export interface ITenantGroupStyles {
  sectionTitle: IStyle;
  container: IStyle;
}

export const tenantGroupStyles = (): ITenantGroupStyles => ({
  sectionTitle: {
    margin: '32px 0 16px 0',
    fontFamily: 'Segoe UI',
    fontWeight: 'bold',
    lineHeight: '20px',
    padding: '8px 8px 8px 0',
    borderBottom: '1px solid #E8E8E8',
    wordBreak: 'break-word'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    listStyle: 'none'
  }
});
